import ImageGallery from './ImageGallery';

export default ImageGallery;


// WEBPACK FOOTER //
// ./src/components/ProductDetail/components/ImageGallery/index.tsx